// extracted by mini-css-extract-plugin
export default {"taskCard":"TaskTypeCard_taskCard__P5dvf"};